import { inject, Injectable } from '@angular/core';
import { AuthenticationService } from '@maersk-global/angular-shared-library';
import { BehaviorSubject, map, Observable, switchMap, take } from 'rxjs';
import { DryUser, PanelVisibility, PanelVisibilityRequest, TypeaheadResponse } from '../models/payload';
import { UserDetailsService } from './user-details.service';
import { SettingsService } from './settings.service';
import { StorageService } from './storage.service';
import { GRID_ROW_DATA, TYPEAHEAD_RECORD_LIMIT } from '../constants/constants';
import { TypeaheadService } from './typeahead.service';

@Injectable({
  providedIn: 'root'
})
export class SharedDataService {

  private dataSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  userRoleCustomers$: Observable<DryUser> = this.dataSubject.asObservable();

  private routeDataSubject = new BehaviorSubject<any>(null);
  routeSharedData$: Observable<any> = this.routeDataSubject.asObservable();

  private customerNamesListSubject = new BehaviorSubject<TypeaheadResponse[]>([]);
  customerNamesList$: Observable<TypeaheadResponse[]> = this.customerNamesListSubject.asObservable();


  private authenticationService = inject(AuthenticationService);
  private userDetails = inject(UserDetailsService);
  private settingsService = inject(SettingsService);
  private storageService = inject(StorageService);
  private typeAheadService = inject(TypeaheadService);

  setuserRoleCustomersData(data: DryUser): void {
    this.dataSubject.next(data);
  }

  setData(data: any): void {
    this.routeDataSubject.next(data);
  }

  setCustomerNamesList(data: TypeaheadResponse[]): void {
    this.customerNamesListSubject.next(data);
  }

  getUserRoleCustomersData(): Observable<DryUser> {
    return this.authenticationService.user$.pipe(switchMap(user => {
      return this.userDetails.findUserRolePermissions(user?.uniqueId).pipe(map(data => {
        this.setuserRoleCustomersData({ ...data, frInformation: user });
        return data;
      }));
    }));
  }

  getCustomersList(): void {
    const request = { CustomerCodes: [], fieldName: "customers", isUser: false, searchText: ' ', typeaheadLimit: TYPEAHEAD_RECORD_LIMIT };
    this.typeAheadService.getBookingContainerTypeahead(request).pipe(take(1)).subscribe({
      next: data => {
        if (data && data.length) {
          this.setCustomerNamesList(data);
        }
      },
      error: () => {
        this.setCustomerNamesList([]);
      }
    });
  }

  getTrackingPageVisibility(): Observable<PanelVisibility> {
    const panelVisibilityRequest: PanelVisibilityRequest =
    {
      CustomerNumber: this.storageService.getData(GRID_ROW_DATA)?.priceOwnerCode,
      ShipmentNumber: this.storageService.getData(GRID_ROW_DATA)?.shipmentNumber,
      ContainerNumber: this.storageService.getData(GRID_ROW_DATA)?.containerNumber,
      DeviceId: this.storageService.getData(GRID_ROW_DATA)?.deviceId
    }
    return this.settingsService.getTrackingPageVisibility(panelVisibilityRequest).pipe(map(data => {
      this.setData(data);
      return data;
    }));
  }

}
